import { createFileRoute, notFound } from '@tanstack/react-router';
import { getWebcast, loadWebcastBody } from '@content/webcasts';
import { cmsHead } from '@lib/cmsHead';
import { WebcastPage } from '@templates/WebcastPage';

export const Route = createFileRoute('/webcast/$slug')({
  loader: async ({ params }) => {
    const webcast = getWebcast(params.slug);
    if (!webcast) throw notFound();
    return { webcast, body: await loadWebcastBody(webcast.slug) };
  },
  head: ({ loaderData }) => (loaderData ? cmsHead(loaderData.webcast.seo, `/webcast/${loaderData.webcast.slug}`) : {}),
  component: WebcastRoute,
});

function WebcastRoute() {
  const { webcast, body } = Route.useLoaderData();
  return <WebcastPage webcast={webcast} body={body} />;
}
